import { UserCardDetailsActionType } from "../Constants/UserCardDetailsActionType";

export const setUserCardDetails = (card) => {
	return {
		type: UserCardDetailsActionType.SET_USER_CARD_DETAILS,
		payload: card,
	};
};
